import AdminHeader from "./components/AdminHeader";
import AdminSidebar from "./components/AdminSidebar";

export default function AdminLayout({
  children,
  currentPath,
  filters,
  locations,
  toasts,
  unreadCount,
  onFilterChange,
  onLogout,
  onNavigate,
}) {
  return (
    <div className="admin-shell">
      <AdminSidebar currentPath={currentPath} onNavigate={onNavigate} />

      <div className="admin-main">
        <AdminHeader
          filters={filters}
          locations={locations}
          unreadCount={unreadCount}
          onFilterChange={onFilterChange}
          onLogout={onLogout}
        />

        <div className="admin-toasts" aria-live="polite">
          {toasts.map((toast) => (
            <div className="alert alert-warning" key={toast.id}>
              {toast.title}
            </div>
          ))}
        </div>

        {children}
      </div>
    </div>
  );
}